// extracted by mini-css-extract-plugin
module.exports = {"CART_BOARD":"CartBoard_CART_BOARD__1Y3vv"};